import type { UserActivationKey } from '@/features/solution-browser/types'

/** Ownership of a series derived from the user's activation keys */
export type SeriesAccess = 'ACTIVE' | 'EXPIRED' | 'NONE'

/** seriesCode -> access; a REDEEMED key wins over an EXPIRED one for the same series */
export function buildSeriesAccessMap(keys: UserActivationKey[]): Map<string, SeriesAccess> {
  const map = new Map<string, SeriesAccess>()
  for (const key of keys) {
    if (key.status === 'REDEEMED') {
      map.set(key.seriesCode, 'ACTIVE')
    } else if (key.status === 'EXPIRED' && !map.has(key.seriesCode)) {
      map.set(key.seriesCode, 'EXPIRED')
    }
  }
  return map
}
